import { extendObservable, toJS } from 'mobx';
import config from 'config';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import http from '../utils/http';
import axios from 'axios';
const FileDownload = require('js-file-download');

const initialMedia = {
  startDate: '',
  endDate: '',
  name: '',
  url: '',
  thumbnail: '',
  tags: [],
  thumbnails: []
};

export class MediaStore {
  constructor() {
    extendObservable(this, {
      loading: false,
      mediaList: [],
      categorySelect: [],
      media: initialMedia,
      mode: 'create',
    });
  }

  setMedias(mediaList) {
    this.mediaList = mediaList;
  }

  setMedia(media) {
    if (media.category.length > 0) {
      media.category.forEach(val => {
        this.categorySelect.push(val.id)
      });
    }
    if (media.tags) {
      media.tags = JSON.parse(media.tags);
    }
    if (media.thumbnails) {
      media.thumbnails = JSON.parse(media.thumbnails);
    }
    this.media = camelcaseKeys(media);
  }

  getMediaJS() {
    return toJS(this.media);
  }

  getMediasJS() {
    return toJS(this.mediaList);
  }

  changeFieldMedia(task, data) {
    this.media[task] = data;
  }

  changeCategorySelect(data) {
    this.categorySelect = data;
  }

  async loadMedia() {
    this.loading = true;
    try {
      const mediaList = await http.get('/media');
      this.setMedias(mediaList ? mediaList.filter(media => media.status !== 'deleted') : []);
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  resetMedia() {
    this.categorySelect = [];
    this.media = initialMedia;
    this.mode = 'create';
  }

  async getMedia(id,task = 'view') {
    this.loading = true;
    try {
      const media = await http.get(`/media/${id}`);
      if (media) {
        this.setMedia(media);
        this.mode = task;
      }
      return this.media;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async createMedia() {
    this.loading = true;
    const data = snakecaseKeys(this.media);
    let category = this.categorySelect.map(val => {
      val = { id: val };
      return val;
    });
    data.category = category;
    data.tags = JSON.stringify(data.tags);
    data.thumbnails = JSON.stringify(data.thumbnails)
    try {
      await http.post('/media', data);
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async downloadVDO(api,url){
    this.loading = true;
    let name = url.replace('https://s3-ap-southeast-1.amazonaws.com/nw-fast-media/media/','');
    try {
      await axios.get(`${api}`,
        {
          responseType: 'arraybuffer'
        }
      ).then((response) => {
        FileDownload(response.data, name);
      });;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async downloadThumb(thumbnails,url) {
    let name = url.replace('https://s3-ap-southeast-1.amazonaws.com/nw-fast-media/media/','');
    name = name.replace('.mp4','');
    name = name+'_THUMBNAILS';
    this.loading = true;
    const data = {};
    data.thumbnails = thumbnails
    data.name = name
    try {
      await axios.post(`${config.s3.url}/api/download-thumbnail`, data,
        {
          responseType: 'arraybuffer'
        }
      ).then((response) => {
        FileDownload(response.data, `${name}.zip`);
      });;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async updateMedia(id) {
    this.loading = true;
    const data = snakecaseKeys(this.media);
    let category = this.categorySelect.map(val => {
      val = { id: val };
      return val;
    });
    data.category = category;
    data.tags = JSON.stringify(data.tags)
    data.thumbnails = JSON.stringify(data.thumbnails)
    try {
      await http.put(`/media/${id}`, data);
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async deleteMedia(id) {
    this.loading = true;
    try {
      const media = await http.delete(`/media/${id}`);
      if (media) {
        this.mediaList = this.mediaList.filter(usr => usr.id !== id);
      }
      return media;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }
}

const mediaStore = new MediaStore();
export default mediaStore;
